import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocationSetsActions } from './location-sets.actions';
import { LocationSetsSelectors } from './location-sets.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {LocationSet} from '@emm/core/models/location-set.model';
import {Venue} from '@emm/core/models/venue.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {LaunchDarklyService} from '@emm/core/services/launch-darkly.service';


export interface LocationSetsQueries extends AsyncActionQueries {
    filter$: Observable<string>;
    filteredLocationSets$: Observable<LocationSet[]>;
    isChainMenu$: Observable<boolean>;
    selected$: Observable<LocationSet>;
    selectedVenue$: Observable<Venue>;
}

@Injectable({
    providedIn: 'root'
})
export class LocationSetsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {
    constructor(store: Store<CoreState>, private launchDarklyService: LaunchDarklyService) {
        super(store, LocationSetsSelectors);
        this.launchDarklyService = launchDarklyService;
    }

    dispatch = {
        selectLocationSet: (tag: string) => {
            this.store.dispatch(LocationSetsActions.select({ tag }));
            this.launchDarklyService.switchContext({
                kind: 'location',
                key: tag,
            });
        },
        loadLocationsByParent: (parentTag: string) =>
            this.store.dispatch(LocationSetsActions.loadLocationsByParent({ parentTag })),
        selectVenue: (venue: Venue) =>
            this.store.dispatch(LocationSetsActions.selectVenue({ venue })),
        updateFilter: (filter: string) =>
            this.store.dispatch(LocationSetsActions.updateFilter({ filter }))
    };

    queries: LocationSetsQueries = {
        filter$: this.select(LocationSetsSelectors.getFilter),
        filteredLocationSets$: this.select(LocationSetsSelectors.getFilteredLocationSets),
        isChainMenu$: this.select(LocationSetsSelectors.getIsChainMenu),
        selected$: this.select(LocationSetsSelectors.getSelected),
        selectedVenue$: this.select(LocationSetsSelectors.getSelectedVenue),
        ...this.asyncActionQueries
    };
}
